export default "__VITE_ASSET__Bw1er_uG__"